import AdminLayout from "../Attachments/AdminLayout";
import AttachmentGroupsTable from "./AttachmentGroupsTable";
import AttachmentGroupPreview from "./AttachmentGroupPreview";
import { router } from '@inertiajs/react';
import { useScreenSize } from "../../../hooks/useScreenSize";

export function handleDelete(id: number, title: string) {
  if (window.confirm(`Are you sure you want to delete group "${title}"? This action cannot be undone.`)) {
    router.delete(`/admin/attachments/groups`,
      {
        data: {
          ids: [id]
        }
      }
    );
  }
}

export default function AttachmentGroupsIndex({
  attachment_groups: attachmentGroups,
  'previewed_group': previewedGroup,
}: any) {
  const { screenLargerThan } = useScreenSize()

  return (
    <AdminLayout>
      <div style={{
        display: 'flex',
        flexDirection: screenLargerThan('md') ? 'row' : 'column',
        gap: '8px',
        flex: 1,
        minHeight: 0,
      }}>
        <div style={{
          flex: 2,
          overflowX: 'hidden',
          backgroundColor: '#ddd'
        }}>
          <AttachmentGroupsTable
            attachmentGroups={attachmentGroups}
            previewedGroup={previewedGroup}
          />
        </div>
        <div style={{
          flex: screenLargerThan('md') ? 1 : 3,
          minHeight: 0,
          overflow: 'hidden'
        }}>
          {previewedGroup ? (
            <AttachmentGroupPreview
              groupRow={previewedGroup}
              onDelete={handleDelete}
              key={`attachment-group-${previewedGroup.id}`}
            />
          ) : (
            <AttachmentGroupPreview
            />
          )}
        </div>
      </div>
    </AdminLayout>
  )
}
